var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-ios-settings",
    "data-name": "Icon ionic-ios-settings",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.929,
    height: 20.935,
    viewBox: "0 0 20.929 20.935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-settings-2",
    "data-name": "Icon ionic-ios-settings",
    d: "M23.7,14.965a2.693,2.693,0,0,1,1.728-2.513A10.675,10.675,0,0,0,24.138,9.34a2.729,2.729,0,0,1-1.1.234,2.687,2.687,0,0,1-2.458-3.783A10.643,10.643,0,0,0,17.477,4.5a2.691,2.691,0,0,1-5.025,0A10.675,10.675,0,0,0,9.34,5.792,2.687,2.687,0,0,1,6.882,9.574a2.64,2.64,0,0,1-1.1-.234A10.911,10.911,0,0,0,4.5,12.457a2.692,2.692,0,0,1,.005,5.025A10.675,10.675,0,0,0,5.8,20.595a2.688,2.688,0,0,1,3.548,3.548,10.738,10.738,0,0,0,3.112,1.292,2.686,2.686,0,0,1,5.014,0,10.675,10.675,0,0,0,3.112-1.292,2.691,2.691,0,0,1,3.548-3.548,10.738,10.738,0,0,0,1.292-3.112A2.706,2.706,0,0,1,23.7,14.965Zm-8.688,4.355a4.36,4.36,0,1,1,4.36-4.36A4.359,4.359,0,0,1,15.014,19.319Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#716f6f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon-settings.d1d11aa8f62b6159d91eb328d17a510f.svg";
export { ForwardRef as ReactComponent };